import {
  ADD_FILTER,
  INGREDIENT_COST_ASYNC_GET_SUCCESS,
  PAGINATED_PRODUCT_UPDATE_SUCCESS,
  PREVIOUSLY_USED_ASYNC_UPDATE_SUCCESS,
  LIST_INGREDIENT_ASYNC_UPDATE_SUCCESS,
  BATCH_RECIPES_ASYNC_UPDATE_SUCCESS,
  SET_LOADING_INGREDIENTS_SEARCH_STATUS,
  UPDATE_INGREDIENTS_PRICE,
  SET_SELECTED_TAB,
  REMOVE_FILTER,
  CLEAR_SELECTED_ITEMS,
  REMOVE_INGREDIENT_FROM_SELECTED_ITEMS,
  UPDATE_INGREDIENT_QTY,
  UPDATE_INGREDIENT_UNIT,
  RESET_ALL,
  RESET_ALL_FILTERS,
  RESET_TAB_FILTERS,
  UPDATE_SELECTED_ITEMS,
  UPDATE_SORT_PROPS,
  UPDATE_SEARCH_KEYWORD,
  UPDATE_SEARCHED_TABS,
  RESET_TAB,
  ADD_NEW_CUSTOM_INGREDIENT,
  ADD_INGREDIENT_TO_SELECTED_ITEMS,
} from 'actions/ingredientsSearch';
import { ingredientsSearchTabs } from 'constants/ingredientsSearch';
import { ingredientTypeMap } from 'constants/ingredientType';

const initialState = {
  purchaseHistoryTab: {},
  previouslyUsedTab: {},
  itemListsTab: {},
  batchRecipesTab: {},
  customIngredientsTab: {
    newIngredients: []
  },
  fullProductCatalogTab: {},
  loading: false,
  selectedTab: ingredientsSearchTabs.PURCHASE_HISTORY_TAB.key,
  selectedIngredients: [],
  selectedFilters: {
    purchaseHistoryTab: {},
    previouslyUsedTab: {},
    itemListsTab: {},
    batchRecipesTab: {},
    customIngredientsTab: {},
    fullProductCatalogTab: {},
  },
  selectedItems: [], // keeps the selected ingredients forthe right section
  search: {
    keyword: '',
    isSupc: false,
    searchedTabs: []
  },
};

const actionsMap = {
  [PAGINATED_PRODUCT_UPDATE_SUCCESS]: (state, action) => {
    const { tabKey, data } = action.data;
    return {
      ...state,
      [tabKey]: data,
    };
  },
  [PREVIOUSLY_USED_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    const { previouslyUsedData, ingredType } = action.data;
    return {
      ...state,
      [
        ingredType === ingredientTypeMap.CUSTOM_INGREDIENTS ?
          ingredientsSearchTabs.CUSTOM_INGREDIENTS_TAB.key :
          ingredientsSearchTabs.PREVIOUSLY_USED_TAB.key
      ]: previouslyUsedData,
    };
  },
  [LIST_INGREDIENT_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    return {
      ...state,
      itemListsTab: action.listIngredientsData,
    };
  },
  [BATCH_RECIPES_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    return {
      ...state,
      batchRecipesTab: action.data,
    };
  },
  [SET_LOADING_INGREDIENTS_SEARCH_STATUS]: (state, action) => {
    return {
      ...state,
      loading: action.isLoading,
    };
  },
  [SET_SELECTED_TAB]: (state, action) => {
    return {
      ...state,
      selectedTab: action.data,
    };
  },
  [UPDATE_INGREDIENTS_PRICE]: (state, action) => {
    const priceList = action.data.prices;
    const ingredients = state[action.data.tab].products;

    return {
      ...state,
      [action.data.tab]: {
        ...state[action.data.tab],
        products: ingredients.map(item => {
          const priceObj = priceList.find(price => price.supc === item.supc);
          if (undefined === priceObj) {
            return item;
          }
          return {
            ...item,
            unitCost: priceObj.unitCost,
            priceLoadSuccess: priceObj.priceLoadSuccess,
            priceLoaded: priceObj.priceLoaded,
            priceStatuses: priceObj.priceStatuses
          };
        }),
      },
    };
  },
  [ADD_FILTER]: (state, action) => {
    // Note: state.selectedFilters[action.data.tab][action.data.facetId] is an array
    // This does not support radio buttons
    const selectedFiltersArray = state.selectedFilters[action.data.tab][action.data.facetId] ?
      [...state.selectedFilters[action.data.tab][action.data.facetId], action.data.filterId] :
      [action.data.filterId];

    return {
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        [action.data.tab]: {
          ...state.selectedFilters[action.data.tab],
          [action.data.facetId]: selectedFiltersArray,
        },
      },
    };
  },
  [REMOVE_FILTER]: (state, action) => {
    return {
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        [action.data.tab]: {
          ...state.selectedFilters[action.data.tab],
          [action.data.facetId]:
            state.selectedFilters[action.data.tab][action.data.facetId]
              .filter(item => item !== action.data.filterId),
        },
      },
    };
  },

  // TODO: remove this reducer (replacing entire array)
  // will be unused with 'add to recipe' validation removal
  [UPDATE_SELECTED_ITEMS]: (state, action) => {
    return {
      ...state,
      selectedIngredients: action.data
    }
  },

  [CLEAR_SELECTED_ITEMS]: (state) => {
    return {
      ...state,
      selectedIngredients: []
    }
  },

  [ADD_INGREDIENT_TO_SELECTED_ITEMS]: (state, action) => {
    return {
      ...state,
      selectedIngredients: [...state.selectedIngredients, action.data.ingredient]
    };
  },

  [REMOVE_INGREDIENT_FROM_SELECTED_ITEMS]: (state, action) => {
    return {
      ...state,
      selectedIngredients: state.selectedIngredients.filter(ingredient => ingredient.uniqKey !== action.data.uniqKey)
    };
  },

  [UPDATE_INGREDIENT_QTY]: (state, action) => {
    const { ingredientUniqKey, qty, isQtyValid } = action.data;

    return {
      ...state,
      selectedIngredients: state.selectedIngredients.map(
          (ingredient) => {
          return (ingredient.uniqKey === ingredientUniqKey) ? { ...ingredient, amountUsedInRecipe: qty, isCostPerServingLoading: true, isQtyValid } : ingredient
          }
      )
    };
  },

  [UPDATE_INGREDIENT_UNIT]: (state, action) => {
    const { ingredientUniqKey, unitCode } = action.data;

    return {
      ...state,
      selectedIngredients: state.selectedIngredients.map(
          (ingredient) => {
            return (ingredient.uniqKey === ingredientUniqKey) ? {...ingredient, amountUnitTextKey: unitCode, isCostPerServingLoading: true} : ingredient
          }
      )
    };
  },

  [INGREDIENT_COST_ASYNC_GET_SUCCESS]: (state, action) => {
    const { ingredientUniqKey, costPerServing } = action.data;

    return {
      ...state,
      selectedIngredients: state.selectedIngredients.map(
          (ingredient) => {
            return (ingredient.uniqKey === ingredientUniqKey) ? {...ingredient, costPerServing, isCostPerServingLoading: false } : ingredient
          }
      )
    };
  },
  [RESET_ALL]: () => initialState,
  [RESET_ALL_FILTERS]: (state) => {
    return {
        ...state,
        selectedFilters: initialState.selectedFilters
    };
  },
  [RESET_TAB_FILTERS]: (state, action) => {
    return {
        ...state,
        selectedFilters: {
            ...state.selectedFilters,
            [action.data]: {}
        }
    };
  },
  // [REHYDRATE]: (state, action) => {
  //   const ingredientsSearchPayload = action.payload.ingredientsSearch;
  //   if (ingredientsSearchPayload) {
  //     return ingredientsSearchPayload;
  //   }
  //   return state;
  // },
  [UPDATE_SORT_PROPS]: (state, action) => {
    const { tabKey, sort } = action.data;
    return {
      ...state,
      [tabKey]: {
        ...state[tabKey],
        sort: { ...sort },
      }
    }
  },
  [UPDATE_SEARCH_KEYWORD]: (state, action) => {
    return {
      ...state,
      search: {
        ...action.data
      }
    }
  },
  [UPDATE_SEARCHED_TABS]: (state, action) => {
    return {
      ...state,
      search: {
        ...state.search,
        searchedTabs: action.data
      }
    }
  },
  [RESET_TAB]: (state, action) => {
    const tabKey = action.data;
    return {
      ...state,
      [tabKey]: {},
      selectedFilters: {
        ...state.selectedFilters,
        [tabKey]: {}
      }
    }
  },
  [ADD_NEW_CUSTOM_INGREDIENT]: (state, action) => {
    const prevIngredients = state[ingredientsSearchTabs.CUSTOM_INGREDIENTS_TAB.key].newIngredients || [];
    return {
      ...state,
      [ingredientsSearchTabs.CUSTOM_INGREDIENTS_TAB.key]: {
        ...state[ingredientsSearchTabs.CUSTOM_INGREDIENTS_TAB.key],
        newIngredients: [
          ...prevIngredients,
          action.data.ingredient,
        ]
      }
    }
  },
};

export default function ingredientsSearch(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
